import React, {useState} from 'react';
import {connect} from 'react-redux';
import {compose} from '../../utils'
import {bindActionCreators} from "redux";
import InputMask from "react-input-mask";
import checkPhoneValidation from "../../utils/check-phone-validation";
import SMS from "../../services/sms";
import {setStep} from "../../actions";
import CountDown from "../../components/countdown";

const smsService = new SMS();

const setPhoneConfirm = (phone, callback, props) => {
    callback("confirm");
    smsService.setPhoneSms(phone, props.orderId);
};

const checkConfirmationCode = (code, errorCallback, props) => {
    smsService.checkConfirmationCode(code, props.orderId).then(res => {
        if (res.data.error) {
            errorCallback(true);
        } else {
            props.setStep(4);
        }
    });
};

const Step3 = (props) => {
    const [phoneVal, setPhoneVal] = useState(props.user.phone.value);
    const [code, setCode] = useState('');
    const [step, setStep] = useState("phone");
    const [error, setError] = useState(false);

    return (
        <>
            {step === "phone" &&
            <div className="modal-content product-request__wrapper modalType2-step modalType2-step2 active">
                <p className="title">Подтвердите свой заказ</p>
                <div className="modalType2__row">
                    <InputMask mask="+7(999)999-99-99" value={phoneVal}
                               onBlur={e => checkPhoneValidation(e.target.value, setPhoneVal)}
                               onChange={e => setPhoneVal(e.target.value)}>
                        <input type="tel" className="modalType2-input" placeholder="Телефон *"/>
                    </InputMask>

                    <button disabled={!phoneVal} onClick={e => setPhoneConfirm(phoneVal, setStep, props)}
                            className="modalType2__redBtn fast_order_step3" style={{border: 0}}>Отправить код
                    </button>
                </div>
            </div>
            }

            {step === "confirm" &&
            <div className="modal-content product-request__wrapper modalType2-step modalType2-step3 active"
                 data-currensstep="3">
                <p className="title">Подтвердите свой заказ</p>

                <span style={{fontSize: "13px"}}>Ваш заказ №{props.orderId} упешно оформлен и подтверждает подтверждения по смс.<br/>Сейчас вам придет код в смс сообщении, введите его в поле ниже.</span>

                <br/>
                <div className="modalType2__row">
                    <span>Полученный код</span>
                    <input value={code} onChange={e => {
                        setCode(e.target.value);
                        setError(false)
                    }}
                           className="modalType2-input modalType2-inputCode"/>
                    <button disabled={code.length !== 4} onClick={e => checkConfirmationCode(code, setError, props)}
                            className="modalType2__redBtn fast_order_step4" style={{border: 0}}>Подтвердить
                    </button>
                </div>

                <span style={{marginTop: "10px", color: "red", height: "20px", fontSize: "13px"}}>{error && <>Не верный код, попробуйте еще раз.</>}</span>

                <CountDown/>
            </div>
            }
        </>

    );
};

const mapStateToProps = ({user, orderId}) => {
    return {user, orderId};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setStep,
    }, dispatch);
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(Step3);
